import React from "react";
import { useMainContext } from "../Context";
import { useNavigate } from "react-router-dom";

const AuthLayout = ({ children }) => {
  const { isLogin } = useMainContext();
  const navigate = useNavigate();
  if (isLogin()) {
    return window.location.replace("/dashboard");
  } else {
    return (
      <div className="auth-layout">
        <div className="box-auth">
          <div className="logo-auth">
            <img src={require("../Assets/images/auth-vector.png")} />
          </div>
          <p className="text-center fs-15 fw-800 lh-26">
            سامانه مدیریت فاکتور مشتریان
          </p>
          {children}
        </div>
        <footer>
          <div className="mb-7">
            <img src={require("../Assets/images/logo-colored.png")} />
          </div>
          <p className="fs-11 fw-600 lh-19 text-main">
            تمامی حقوق این سامانه برای فراز اس‌ام‌اس محفوظ می‌باشد.
          </p>
        </footer>
      </div>
    );
  }
};

export default AuthLayout;
